if (!customElements.get('bestsellers-tabs')) {
  customElements.define('bestsellers-tabs', class BestsellersTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('.collection_tabs__tab');
      this.sliderEl = this.querySelector('.bestsellers-tabs__slider');
      this.viewAll = this.querySelector('.bestsellers__view-all');

      this.sliderInstance = null;
      this.currentHandle = this.sliderEl?.dataset.handle || '';
      this.skeletonHTML = '';

      this.cache = new Map();
      this.activeAbortController = null;

      this.onTabClick = this.onTabClick.bind(this);
      this.tabs.forEach(tab => tab.addEventListener('click', this.onTabClick));

      document.addEventListener('DOMContentLoaded', () => {
        if (this.sliderEl) {
          this.skeletonHTML = [...this.sliderEl.querySelectorAll('.bestsellers-skeleton-slide')]
            .map(el => el.outerHTML)
            .join('');
          this.mountSlider(this.sliderEl);
        }
      });
    }

    normalizeCollectionHandle(raw) {
      if (!raw) return '';
      let h = String(raw).trim();
      const match = h.match(/\/collections\/([^/?#]+)/i);
      if (match && match[1]) h = match[1];
      h = h.replace(/^\/+|\/+$/g, '');
      if (h.startsWith('collections/')) h = h.replace('collections/', '');
      return h;
    }

    getSplideOptions() {
      return {
        type: 'slide',
        focus: 0,
        drag: true,
        pagination: true,
        arrows: true,
        mediaQuery: 'max',
        omitEnd: true,
        trimSpace: true
      };
    }

    mountSlider(sliderEl) {
      if (!sliderEl || !sliderEl.querySelector('.splide__slide')) return;
      this.sliderInstance = new Splide(sliderEl, this.getSplideOptions()).mount();
    }

    destroySlider() {
      if (this.sliderInstance) {
        try { this.sliderInstance.destroy(); } catch (e) {}
        this.sliderInstance = null;
      }
    }

    async fetchSectionHTML(handle, signal) {
      if (this.cache.has(handle)) return this.cache.get(handle);

      const res = await fetch(`/collections/${handle}?sections=section-bestsellers-products`, { signal });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      const data = await res.json();
      const temp = document.createElement('div');
      temp.innerHTML = data['section-bestsellers-products'] || '';
      const html = (temp.querySelector('.shopify-section') || temp).innerHTML.trim();

      this.cache.set(handle, html);
      return html;
    }

    async loadCollection(handle) {
      if (!this.sliderEl) return;

      const listEl = this.sliderEl.querySelector('.splide__list');
      if (!listEl) return;

      if (this.activeAbortController) this.activeAbortController.abort();
      this.activeAbortController = new AbortController();

      // Lock height before touching the DOM to prevent page jump
      this.sliderEl.style.minHeight = `${this.sliderEl.offsetHeight}px`;
      this.destroySlider();
      this.sliderEl.classList.add('is-loading');

      try {
        const html = await this.fetchSectionHTML(handle, this.activeAbortController.signal);

        // Re-append skeleton HTML so it survives across multiple tab switches
        listEl.innerHTML = html + this.skeletonHTML;
        this.sliderEl.classList.remove('is-loading');
        this.mountSlider(this.sliderEl);
        this.sliderEl.style.minHeight = '';
        this.currentHandle = handle;

        if (window.updateSizesArrayFinder) {
          window.updateSizesArrayFinder(this.sliderEl);
        }
      } catch (err) {
        if (err?.name !== 'AbortError') console.error('[bestsellers-tabs] load failed:', err);
      }
    }

    setActiveTabStyles(activeTab) {
      this.tabs.forEach((tab) => {
        tab.classList.remove('collection_tabs__tab-active', 'g-btn-fill-primary');
        tab.classList.add('g-btn-outline-secondary');
      });
      activeTab.classList.add('collection_tabs__tab-active', 'g-btn-fill-primary');
      activeTab.classList.remove('g-btn-outline-secondary');
    }

    updateCTAFromTab(tab) {
      const buttonText = tab.dataset.text;
      const buttonUrl = tab.dataset.url;
      if (buttonText && buttonUrl && this.viewAll) {
        this.viewAll.href = buttonUrl;
        const span = this.viewAll.querySelector('.view-all-text');
        if (span) span.textContent = buttonText;
      }
    }

    async onTabClick(event) {
      const tab = event.currentTarget;
      const handle = this.normalizeCollectionHandle(tab.dataset.handle);

      if (handle === this.currentHandle) return;

      this.setActiveTabStyles(tab);
      this.updateCTAFromTab(tab);
      await this.loadCollection(handle);
    }
  });
}
